import {useQuery} from "@tanstack/react-query";
import {useEffect, useRef, useState} from "react";
import {useSearchParams} from "react-router";
import {Template} from "../../../components/template/template.jsx";
import HeaderButtons from "../../../components/reports/report-menu/header-buttons.jsx";
import {Card} from "../../../components/card/card.jsx";
import NoDataContent from "../../../components/reports/report-menu/no-data-content.jsx";
import Content from "./components/content.jsx";
import materialXStorageService from "../../../services/web/material-x-storage-service.js";

const MaterialXStorageInfo = () => {
    const [headerSelected, setHeaderSelected] = useState(-1);
    const [isPrinting, setIsPrinting] = useState(false);
    const [forcePrint, setForcePrint] = useState(true);
    const printComponentRef = useRef(null);

    const title = "Materiais por depósito";

    const [searchParams] = useSearchParams();
    const encodedFilters = searchParams.get("f");

    const filters = encodedFilters ? JSON.parse(decodeURIComponent(atob(encodedFilters))) : {};

    const appliedFilters = [
        { field: "storage", type: "like", value: filters.storage },
        { field: "group", type: "like", value: filters.group },
        { field: "material", type: "like", value: filters.material }
    ].filter(item =>
        item.value !== null &&
        item.value !== undefined &&
        item.value !== ""
    );

    const { data: reportData = [], isLoading: isLoadingReport } = useQuery({
        queryKey: ["materials-x-storage", { appliedFilters }],
        queryFn: async () => {
            const { data } = await materialXStorageService.list(appliedFilters);
            return data;
        }
    });

    const filteredReportData = reportData.filter(item => {
        if (filters.storage && !item.storage?.toLowerCase().includes(filters.storageLabel.toLowerCase())) return false;
        if (filters.group && !item.group?.toLowerCase().includes(filters.groupLabel.toLowerCase())) return false;
        if (filters.material && !item.material?.toLowerCase().includes(filters.material.toLowerCase())) return false;

        return true;
    });

    const hasData = filteredReportData?.length > 0;

    useEffect(() => {
        if (forcePrint === false || !reportData) return;

        setTimeout(() => {
            printComponentRef.current?.print();
        }, 800)

        setForcePrint(false);
    }, [reportData]);

    return (
        <>
            <Template isLoading={isLoadingReport || isPrinting}>
                <Template.Header>
                    <Template.Title>{title}</Template.Title>
                    <HeaderButtons
                        printable={true}
                        printComponentRef={printComponentRef}
                        reportData={filteredReportData}
                        data={hasData}
                        headerChange={true}
                        headerSelected={headerSelected}
                        setHeaderSelected={setHeaderSelected}
                    />
                </Template.Header>
                <Template.Body>
                    <Card className={`w-full mx-auto px-2! ${!hasData ? "!bg-[#f3f3f4] border-none" : ""}`}>
                        <Card.Body>
                            <NoDataContent reportData={filteredReportData} data={!hasData && 0}/>
                            <Content
                                reportData={filteredReportData}
                                data={hasData}
                                entity={headerSelected}
                                title={title}
                                printComponentRef={printComponentRef}
                                setIsPrinting={setIsPrinting}
                            />
                        </Card.Body>
                    </Card>
                </Template.Body>
            </Template>
        </>
    )
};

export default MaterialXStorageInfo;